import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TurnInto = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 28 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M4.03223 22.4013C5.62548 25.8663 10.125 27.125 14.9375 24.9375C13.0772 23.5898 6.96069 22.7035 4.03223 22.4013Z"
        fill={color}
        stroke={color}
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M9.09035 24.273C3.96147 27.8879 1.95626 17.0726 2.22656 13.125C4.26902 14.4852 6.96039 15.2796 9.10681 15.1215C9.36066 20.3254 14.315 23.7154 16.4406 23.861C15.375 24.9375 11.9398 27.2138 9.09035 24.273Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M25.7949 12.5094L26.5588 3.15299L17.5292 2.14756L19.6217 5.28743C15.3527 8.48921 10.5157 15.9054 7.88209 20.2287C12.0753 19.0002 20.6889 13.2917 23.5977 9.89273L25.7949 12.5094Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7508 13.486L10.6987 7.27371L4.29382 10.9377L7.1978 11.9147C7.12997 13.0772 7.13369 16.0559 7.59026 20.1412C9.67307 17.2688 10.191 16.6855 12.0396 12.8971L14.7508 13.486Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8698 23.773L25.2618 15.7641L17.5624 10.9375L18.1885 14.6584C16.8867 15.2601 12.5866 17.3963 8.41574 20.2652C12.7448 20.8583 14.7467 20.68 19.9343 20.4867L20.8698 23.773Z"
        fill="white"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default TurnInto
